import React from 'react';
import doctor from '../../../images/doctor.png';
import './Appointment.css';

const Appointment = () => {
    return (
        <div className="appointment my-5">
            <div className="container">
                <div className="row ">
                    <div className="col-md-5 d-none d-md-block">
                        <img src={doctor} alt="" />
                    </div>
                    <div className="col-md-7 text-white py-5">
                        <h5 className="brand-color text-uppercase"
                            style={{
                                fontWeight: "bold"
                            }}>AppointMent</h5>
                        <h1 className="">Make an Appointment <br /> today </h1>
                        <p>"Take the first step towards a healthier smile - make your appointment today!"</p>
                        <button className="btn btn-primary"
                            style={{
                                backgroundImage: "linear-gradient(to right,#019CAD, #4880EC )",
                                color: 'white'
                            }}>Learn More</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Appointment;